import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Layout from "../components/layout"

export default (props) => {

  const data2 = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            ver
          }
        },

        index: allFile(filter: {sourceInstanceName: {eq: "partCommon"}, relativeDirectory: {eq: ""}}, sort: {fields: base}) {
          edges {
            node {
              name
              base
            }
          }
        },
        allMarkdownRemark {
          nodes {
            html
            parent {
              ... on File {
                name
                sourceInstanceName
              }
            }
          }
        }

      }
    `
  )
  console.log(props, data2);

  const {uri} = props;

  let pageName =  uri;
  let html='';

  //name = props.path.substr(12);
  //pageName = pageContext.slug;
  //console.log(pageName);
  pageName = pageName.substr(1);
  pageName || (pageName = 'introduction');

  //for (let index in data2.allMarkdownRemark.nodes)
  //console.log(data2.allMarkdownRemark.nodes[index].parent.name);

  for (let index in data2.allMarkdownRemark.nodes)
    if (data2.allMarkdownRemark.nodes[index].parent.sourceInstanceName==="page" &&
      data2.allMarkdownRemark.nodes[index].parent.name===pageName){
      html=data2.allMarkdownRemark.nodes[index].html;
      break;
    }

  //console.log(pageName, html);

  return (
    <Layout page={pageName} components={
      data2.index.edges.map(({node}, index) => {

      let name;
      if (node.name[0]==='-')
        name = node.name.substr(1) + ' Components';
      else {
        name = node.name.substr(1);
      }

      return (
        {
          title: name,
          path: 'components/'+node.name,
          isActive: false,
          state: {name: node.name}
        }
      )})
    }>

    <div dangerouslySetInnerHTML={{__html: html}}></div>

  </Layout>)

}
